import React from 'react';
import { shadeColor } from '../../../helpers';
// SVG base, background + folder paper
const PAGE_PATH = 'M3 1.5C3 0.671574 3.67157 0 4.5 0H17.5147L24 6.48535V28.5C24 29.3284 23.3284 30 22.5 30H4.5C3.67157 30 3 29.3284 3 28.5V1.5Z';
const FOLD_PATH = 'M17.5146 0H17V5.5C17 6.32843 17.6716 7 18.5 7H24V6.48535L17.5146 0Z';
export const FILE_ICON_INVERSE = '#FFFFFF';
export const FileIconBase = ({ color, defaultColor, width = 24, height = 30, className, label, children, }) => {
    const fill = color !== null && color !== void 0 ? color : defaultColor;
    return (React.createElement("svg", { width: width, height: height, viewBox: "0 0 24 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: className },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: PAGE_PATH, fill: fill }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: FOLD_PATH, fill: shadeColor(fill, 35) }),
        label && (React.createElement("text", { x: "13.5", y: "22", textAnchor: "middle", fontFamily: "Arial, Helvetica, sans-serif", fontSize: "6", fontWeight: "700", letterSpacing: "0.2", fill: FILE_ICON_INVERSE }, label)),
        children));
};
